import {times} from 'lodash';
import Mock from "mockjs";

export const course_name = [
  "动物解剖与组织胚胎学",
  "动物生理学",
  "动物生物化学",
  "兽医病理学",
  "兽医药理学",
  "兽医微生物学与免疫学",
  "兽医内科学",
  "兽医外科学",
  "动物寄生虫学",
  "寄生虫病学",
  "动物传染病学",
  "特种经济动物学",
  "兽医产科学",
  '科学社会主义与国际共产主义运动搜索',
  '国际政治',
  '国际关系',
  '中共党史(含：党的学说与党的建设)',
  '国外马克思主义研究'
];

export const agent_name = [
  '杭州开元书局',
  '伍同图书管理公司'
];

export const publish_name = [
  '科学出版社',
  '教育出版社',
  '机械出版社',
  '清华大学出版社',
  '浙江大学出版社'
];


export const class_name = times(100, function (item) {
  return [
    '应物',
    '电信',
    '中信',
    '物联',
    '计算机',
    '软件工程'
  ][item%6] + (item%6) +'班';
});

export const edition = [
  '第一版',
  '第二版',
  '第三版',
  '第四版',
  '第五版',
]

export const college = [
  '电子信息学院',
  '文学院',
  '物理学院',
  '医学院',
  '文理学院',
  '继续教育学院',
  '城市建设学院',
  '外国语学院',
  '艺术学院',
  '城市建设学院'
];
export const grades = [
  '2018届',
  '2017届',
  '2016届',
  '2015届',
  '2014届',
  '2013届',
  '2012届',
]

export const campus = [
  '下沙校区',
  '海宁校区'
]


export const season = times(20, function (i) {
  return `${2018 - Math.floor(i / 2)}年${['春', '秋'][i % 2]}季`
});



// WEBPACK FOOTER //
// ./src/mock/datas.js